/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DockerRunArtifactData } from './DockerRunArtifactData';
import { DockerRunArtifactDataFromJSON, DockerRunArtifactDataFromJSONTyped, DockerRunArtifactDataToJSON, } from './DockerRunArtifactData';
import type { DockerRunState } from './DockerRunState';
import { DockerRunStateFromJSON, DockerRunStateFromJSONTyped, DockerRunStateToJSON, } from './DockerRunState';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerRunData
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_DockerRunData_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DockerRunData_datasetId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DockerRunData_configId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DockerRunData_scheduledId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface DockerRunData {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DockerRunData
        
        
    * @pattern_DockerRunData_id
         */
    id: string;
    /**
     *
     * #type string
     * #memberof DockerRunData
        
        
         */
    userId: string;
    /**
     *
     * #type string
     * #memberof DockerRunData
        
        
         */
    dockerVersion: string;
    /**
     *
     * #type DockerRunState
     * #memberof DockerRunData
        
        
         */
    state: DockerRunState;
    /**
     * if the run is archived
     * #type boolean
     * #memberof DockerRunData
        
        
         */
    archived?: boolean;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DockerRunData
        
        
    * @pattern_DockerRunData_datasetId
         */
    datasetId?: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DockerRunData
        
        
    * @pattern_DockerRunData_configId
         */
    configId?: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DockerRunData
        
        
    * @pattern_DockerRunData_scheduledId
         */
    scheduledId?: string;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof DockerRunData
        
    * @minimum 0
            
         */
    createdAt: number;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof DockerRunData
        
    * @minimum 0
            
         */
    lastModifiedAt: number;
    /**
     * last message sent to the docker run
     * #type string
     * #memberof DockerRunData
        
        
         */
    message?: string;
    /**
     * list of artifacts that were created for a run
     * #type Array<DockerRunArtifactData>
     * #memberof DockerRunData
        
        
         */
    artifacts?: Array<DockerRunArtifactData>;
}
/**
 * Check if a given object implements the DockerRunData interface.
 */
export function instanceOfDockerRunData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "dockerVersion" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "lastModifiedAt" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DockerRunArtifactDataValidator, DockerRunArtifactDataStringifyShape, DockerRunArtifactDataStringifyShapeProperties, } from './DockerRunArtifactData';
import { DockerRunStateValidator, DockerRunStateStringifyShape, DockerRunStateStringifyShapeProperties, } from './DockerRunState';
export const DockerRunDataTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerRunData => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerRunData => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_DockerRunData_id", "string", "", input.id) && "string" === typeof input.userId && "string" === typeof input.dockerVersion && ("STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state) && (undefined === input.archived || "boolean" === typeof input.archived) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_DockerRunData_datasetId", "string", "", input.datasetId)) && (undefined === input.configId || "string" === typeof input.configId && $is_custom("pattern_DockerRunData_configId", "string", "", input.configId)) && (undefined === input.scheduledId || "string" === typeof input.scheduledId && $is_custom("pattern_DockerRunData_scheduledId", "string", "", input.scheduledId)) && ("number" === typeof input.createdAt && 0 <= input.createdAt) && ("number" === typeof input.lastModifiedAt && 0 <= input.lastModifiedAt) && (undefined === input.message || "string" === typeof input.message) && (undefined === input.artifacts || Array.isArray(input.artifacts) && input.artifacts.every((elem: any, _index1: number) => "object" === typeof elem && null !== elem && $io1(elem, true && _exceptionable))) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "userId", "dockerVersion", "state", "archived", "datasetId", "configId", "scheduledId", "createdAt", "lastModifiedAt", "message", "artifacts"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_DockerRunArtifactData_id", "string", "", input.id) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type) && "string" === typeof input.fileName && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation) && (undefined === input.createdAt || "number" === typeof input.createdAt && 0 <= input.createdAt) && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "type", "fileName", "storageLocation", "createdAt"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_DockerRunData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DockerRunData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.userId || $guard(_exceptionable, {
                    path: _path + ".userId",
                    expected: "string",
                    value: input.userId
                })) && ("string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "string",
                    value: input.dockerVersion
                })) && ("STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\")",
                    value: input.state
                })) && (undefined === input.archived || "boolean" === typeof input.archived || $guard(_exceptionable, {
                    path: _path + ".archived",
                    expected: "(boolean | undefined)",
                    value: input.archived
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_DockerRunData_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_DockerRunData_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.configId || "string" === typeof input.configId && ($is_custom("pattern_DockerRunData_configId", "string", "", input.configId) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "string (@pattern_DockerRunData_configId)",
                    value: input.configId
                })) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "(string | undefined)",
                    value: input.configId
                })) && (undefined === input.scheduledId || "string" === typeof input.scheduledId && ($is_custom("pattern_DockerRunData_scheduledId", "string", "", input.scheduledId) || $guard(_exceptionable, {
                    path: _path + ".scheduledId",
                    expected: "string (@pattern_DockerRunData_scheduledId)",
                    value: input.scheduledId
                })) || $guard(_exceptionable, {
                    path: _path + ".scheduledId",
                    expected: "(string | undefined)",
                    value: input.scheduledId
                })) && ("number" === typeof input.createdAt && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("number" === typeof input.lastModifiedAt && (0 <= input.lastModifiedAt || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number (@minimum 0)",
                    value: input.lastModifiedAt
                })) || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number",
                    value: input.lastModifiedAt
                })) && (undefined === input.message || "string" === typeof input.message || $guard(_exceptionable, {
                    path: _path + ".message",
                    expected: "(string | undefined)",
                    value: input.message
                })) && (undefined === input.artifacts || (Array.isArray(input.artifacts) || $guard(_exceptionable, {
                    path: _path + ".artifacts",
                    expected: "(Array<DockerRunArtifactData> | undefined)",
                    value: input.artifacts
                })) && input.artifacts.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".artifacts[" + _index1 + "]",
                    expected: "DockerRunArtifactData",
                    value: elem
                })) && $ao1(elem, _path + ".artifacts[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".artifacts[" + _index1 + "]",
                    expected: "DockerRunArtifactData",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".artifacts",
                    expected: "(Array<DockerRunArtifactData> | undefined)",
                    value: input.artifacts
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "userId", "dockerVersion", "state", "archived", "datasetId", "configId", "scheduledId", "createdAt", "lastModifiedAt", "message", "artifacts"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_DockerRunArtifactData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DockerRunArtifactData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                    value: input.type
                })) && ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation || $guard(_exceptionable, {
                    path: _path + ".storageLocation",
                    expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                    value: input.storageLocation
                })) && (undefined === input.createdAt || "number" === typeof input.createdAt && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "(number | undefined)",
                    value: input.createdAt
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "type", "fileName", "storageLocation", "createdAt"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerRunDataTypiaAssertStringify = (input: DockerRunData): string => {
    return ((input: any): string => { const assert = (input: any): DockerRunData => {
        const __is = (input: any): input is DockerRunData => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "string" === typeof input.id && $is_custom("pattern_DockerRunData_id", "string", "", input.id) && "string" === typeof input.userId && "string" === typeof input.dockerVersion && ("STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state) && (undefined === input.archived || "boolean" === typeof input.archived) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_DockerRunData_datasetId", "string", "", input.datasetId)) && (undefined === input.configId || "string" === typeof input.configId && $is_custom("pattern_DockerRunData_configId", "string", "", input.configId)) && (undefined === input.scheduledId || "string" === typeof input.scheduledId && $is_custom("pattern_DockerRunData_scheduledId", "string", "", input.scheduledId)) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && 0 <= input.createdAt) && ("number" === typeof input.lastModifiedAt && !Number.isNaN(input.lastModifiedAt) && 0 <= input.lastModifiedAt) && (undefined === input.message || "string" === typeof input.message) && (undefined === input.artifacts || Array.isArray(input.artifacts) && input.artifacts.every((elem: any) => "object" === typeof elem && null !== elem && $io1(elem)));
            const $io1 = (input: any): boolean => "string" === typeof input.id && $is_custom("pattern_DockerRunArtifactData_id", "string", "", input.id) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type) && "string" === typeof input.fileName && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation) && (undefined === input.createdAt || "number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && 0 <= input.createdAt);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_DockerRunData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DockerRunData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.userId || $guard(_exceptionable, {
                    path: _path + ".userId",
                    expected: "string",
                    value: input.userId
                })) && ("string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "string",
                    value: input.dockerVersion
                })) && ("STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\")",
                    value: input.state
                })) && (undefined === input.archived || "boolean" === typeof input.archived || $guard(_exceptionable, {
                    path: _path + ".archived",
                    expected: "(boolean | undefined)",
                    value: input.archived
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_DockerRunData_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_DockerRunData_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.configId || "string" === typeof input.configId && ($is_custom("pattern_DockerRunData_configId", "string", "", input.configId) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "string (@pattern_DockerRunData_configId)",
                    value: input.configId
                })) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "(string | undefined)",
                    value: input.configId
                })) && (undefined === input.scheduledId || "string" === typeof input.scheduledId && ($is_custom("pattern_DockerRunData_scheduledId", "string", "", input.scheduledId) || $guard(_exceptionable, {
                    path: _path + ".scheduledId",
                    expected: "string (@pattern_DockerRunData_scheduledId)",
                    value: input.scheduledId
                })) || $guard(_exceptionable, {
                    path: _path + ".scheduledId",
                    expected: "(string | undefined)",
                    value: input.scheduledId
                })) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("number" === typeof input.lastModifiedAt && !Number.isNaN(input.lastModifiedAt) && (0 <= input.lastModifiedAt || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number (@minimum 0)",
                    value: input.lastModifiedAt
                })) || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number",
                    value: input.lastModifiedAt
                })) && (undefined === input.message || "string" === typeof input.message || $guard(_exceptionable, {
                    path: _path + ".message",
                    expected: "(string | undefined)",
                    value: input.message
                })) && (undefined === input.artifacts || (Array.isArray(input.artifacts) || $guard(_exceptionable, {
                    path: _path + ".artifacts",
                    expected: "(Array<DockerRunArtifactData> | undefined)",
                    value: input.artifacts
                })) && input.artifacts.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".artifacts[" + _index1 + "]",
                    expected: "DockerRunArtifactData",
                    value: elem
                })) && $ao1(elem, _path + ".artifacts[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".artifacts[" + _index1 + "]",
                    expected: "DockerRunArtifactData",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".artifacts",
                    expected: "(Array<DockerRunArtifactData> | undefined)",
                    value: input.artifacts
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_DockerRunArtifactData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DockerRunArtifactData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                    value: input.type
                })) && ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation || $guard(_exceptionable, {
                    path: _path + ".storageLocation",
                    expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                    value: input.storageLocation
                })) && (undefined === input.createdAt || "number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "(number | undefined)",
                    value: input.createdAt
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerRunData): string => {
        const $io1 = (input: any): boolean => "string" === typeof input.id && $is_custom("pattern_DockerRunArtifactData_id", "string", "", input.id) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type) && "string" === typeof input.fileName && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation) && (undefined === input.createdAt || "number" === typeof input.createdAt && 0 <= input.createdAt);
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.archived ? "" : `"archived":${undefined !== input.archived ? input.archived : undefined},`}${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.configId ? "" : `"configId":${undefined !== input.configId ? $string(input.configId) : undefined},`}${undefined === input.scheduledId ? "" : `"scheduledId":${undefined !== input.scheduledId ? $string(input.scheduledId) : undefined},`}${undefined === input.message ? "" : `"message":${undefined !== input.message ? $string(input.message) : undefined},`}${undefined === input.artifacts ? "" : `"artifacts":${undefined !== input.artifacts ? `[${input.artifacts.map((elem: any) => $so1(elem)).join(",")}]` : undefined},`}"id":${$string(input.id)},"userId":${$string(input.userId)},"dockerVersion":${$string(input.dockerVersion)},"state":${(() => {
            if ("string" === typeof input.state)
                return $string(input.state);
            if ("string" === typeof input.state)
                return "\"" + input.state + "\"";
            $throws({
                expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\")",
                value: input.state
            });
        })()},"createdAt":${input.createdAt},"lastModifiedAt":${input.lastModifiedAt}}`;
        const $so1 = (input: any): any => `{${undefined === input.storageLocation ? "" : `"storageLocation":${undefined !== input.storageLocation ? (() => {
            if ("string" === typeof input.storageLocation)
                return $string(input.storageLocation);
            if ("string" === typeof input.storageLocation)
                return "\"" + input.storageLocation + "\"";
            $throws({
                expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                value: input.storageLocation
            });
        })() : undefined},`}${undefined === input.createdAt ? "" : `"createdAt":${undefined !== input.createdAt ? input.createdAt : undefined},`}"id":${$string(input.id)},"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                value: input.type
            });
        })()},"fileName":${$string(input.fileName)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerRunDataValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'userId': yup.string().defined(),
    'dockerVersion': yup.string().defined(),
    'state': DockerRunStateValidator.defined(),
    'archived': yup.boolean(),
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/),
    'configId': yup.string().matches(/^[a-f0-9]{24}$/),
    'scheduledId': yup.string().matches(/^[a-f0-9]{24}$/),
    'createdAt': yup.number().min(0).defined(),
    'lastModifiedAt': yup.number().min(0).defined(),
    'message': yup.string(),
    'artifacts': yup.array().of(DockerRunArtifactDataValidator),
};
export const DockerRunDataValidator = yup.object().shape(DockerRunDataValidatorShape);
export const DockerRunDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'userId': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'dockerVersion': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'state': DockerRunStateStringifyShape,
    'archived': {
        'type': 'boolean',
    },
    'datasetId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'configId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'scheduledId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'createdAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'lastModifiedAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'message': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'artifacts': {
        type: 'array',
        items: {
            DockerRunArtifactDataStringifyShape
        }
    },
};
export const DockerRunDataStringifyShape: ObjectSchema = {
    title: 'DockerRunData Stringifier',
    type: 'object',
    properties: {
        ...DockerRunDataStringifyShapeProperties
    },
    required: [
        'id',
        'userId',
        'dockerVersion',
        'state',
        'createdAt',
        'lastModifiedAt',
    ],
};
export const DockerRunDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerRunDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerRunDataStringify: (data: DockerRunData) => string = DockerRunDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerRunDataFromJSON(json: any): DockerRunData {
    return DockerRunDataFromJSONTyped(json, false);
}
export function DockerRunDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerRunData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'userId': json['userId'],
        'dockerVersion': json['dockerVersion'],
        'state': DockerRunStateFromJSON(json['state']),
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
        'datasetId': !exists(json, 'datasetId') ? undefined : json['datasetId'],
        'configId': !exists(json, 'configId') ? undefined : json['configId'],
        'scheduledId': !exists(json, 'scheduledId') ? undefined : json['scheduledId'],
        'createdAt': json['createdAt'],
        'lastModifiedAt': json['lastModifiedAt'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'artifacts': !exists(json, 'artifacts') ? undefined : ((json['artifacts'] as Array<any> || []).map(DockerRunArtifactDataFromJSON)),
    };
}
export function DockerRunDataToJSON(value?: DockerRunData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'userId': value.userId,
        'dockerVersion': value.dockerVersion,
        'state': DockerRunStateToJSON(value.state),
        'archived': value.archived,
        'datasetId': value.datasetId,
        'configId': value.configId,
        'scheduledId': value.scheduledId,
        'createdAt': value.createdAt,
        'lastModifiedAt': value.lastModifiedAt,
        'message': value.message,
        'artifacts': value.artifacts === undefined ? undefined : ((value.artifacts as Array<any> || []).map(DockerRunArtifactDataToJSON)),
    };
}
